import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    FormGroup,
} from "reactstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CommonHeader from "components/Headers/CommonHeader.js";
import { getPrivacyPolicy, savePrivacyPolicy } from "api/ApiServices";
import Swal from "sweetalert2";
import { MdSecurity } from "react-icons/md";
const PrivacyPolicy = () => {
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchPrivacyPolicy();
    }, []);

    const fetchPrivacyPolicy = async () => {
        console.log("fetchPrivacyPolicy");
        try {
            setLoading(true);
            const response = await getPrivacyPolicy();
            console.log("Full response:", response);

            if (response?.success) {
                // ✅ FIX: Get content from response.data.content
                const policyContent = response?.data?.content || "";
                console.log("Content:", policyContent);
                setContent(policyContent);
            } else {
                setContent("");
                console.log("No privacy policy found:", response?.message);
            }
        } catch (error) {
            console.error("Error fetching privacy policy:", error);
            setContent("");
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            if (!content.trim()) {
                Swal.fire("Error", "Privacy Policy content cannot be empty", "error");
                return;
            }

            setLoading(true);

            // ✅ FIX: Send ALL required fields (title and content)
            const payload = {
                title: "Privacy Policy",  // Required field
                content: content          // Required field
            };

            console.log("Saving payload:", payload);

            const response = await savePrivacyPolicy(payload);
            console.log("Save response:", response);

            if (response?.success) {
                Swal.fire(
                    "Success",
                    response?.message || "Privacy Policy updated successfully",
                    "success"
                );
                // Refresh the data after save
                await fetchPrivacyPolicy();
            } else {
                Swal.fire(
                    "Error",
                    response?.message || "Something went wrong",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error saving privacy policy:", error);

            // Get error message from response
            const errorMessage = error?.response?.data?.message ||
                error?.message ||
                "Failed to save privacy policy";

            Swal.fire("Error", errorMessage, "error");
        } finally {
            setLoading(false);
        }
    };

    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            ["clean"],
        ],
    };

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "link",
        "image",
    ];

    return (
        <>
            <CommonHeader />
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="bg-transparent py-3 py-sm-4 px-3 px-sm-4">
                                <Row className="align-items-center justify-content-between">
                                    <Col xs="12" sm="auto" className="mb-2 mb-sm-0">
                                        <h3 className="mb-0 text-dark font-weight-700">
                                            <MdSecurity
                                                className="button-primary-color mr-2"
                                                size={22}
                                                style={{ verticalAlign: "middle" }}
                                            />
                                            Manage Privacy Policy
                                        </h3>
                                    </Col>

                                    <Col xs="12" sm="auto">
                                        <Button
                                            color="primary"
                                            onClick={handleSave}
                                            disabled={loading}
                                            size="md"
                                            className="px-4 button-secondary bg-button-gradient-primary w-100"
                                            style={{ borderRadius: 8, border: "none" }}
                                        >
                                            {loading ? (
                                                <>
                                                    <i className="fas fa-spinner fa-spin mr-2" />
                                                    Saving...
                                                </>
                                            ) : (
                                                "Save Changes"
                                            )}
                                        </Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody className="px-3 px-sm-4 py-3 py-sm-4">
                                <FormGroup className="mb-0">
                                    <div className="quill-editor-wrapper">
                                        <ReactQuill
                                            theme="snow"
                                            value={content}
                                            onChange={setContent}
                                            modules={modules}
                                            formats={formats}
                                            placeholder="Write privacy policy content here..."
                                        />
                                    </div>
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default PrivacyPolicy;